var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLineas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 514,
    height: 113.769,
    viewBox: "0 0 514 113.769",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_10",
    "data-name": "Rect\\xE1ngulo 10",
    width: 514,
    height: 99.023,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15",
    "data-name": "Grupo 15",
    transform: "translate(514 -2434)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13",
    "data-name": "Grupo 13",
    transform: "translate(-514 2448.746)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_12",
    "data-name": "Grupo 12",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25",
    "data-name": "Trazado 25",
    d: "M416.436,326.223l-46.784,75.012h-6.671l46.681-75.012Z",
    transform: "translate(124.291 -315.165)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_26",
    "data-name": "Trazado 26",
    d: "M405.562,326.223l-46.787,75.012h-6.668l46.679-75.012Z",
    transform: "translate(108.439 -315.165)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27",
    "data-name": "Trazado 27",
    d: "M394.687,326.223,347.9,401.236h-6.671l46.681-75.012Z",
    transform: "translate(92.585 -315.165)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_28",
    "data-name": "Trazado 28",
    d: "M383.813,326.223l-46.787,75.012h-6.668l46.679-75.012Z",
    transform: "translate(76.733 -315.165)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_29",
    "data-name": "Trazado 29",
    d: "M372.937,326.223l-46.784,75.012h-6.668l46.679-75.012Z",
    transform: "translate(60.88 -315.165)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_30",
    "data-name": "Trazado 30",
    d: "M362.064,326.223l-46.787,75.012h-6.668l46.681-75.012Z",
    transform: "translate(45.027 -315.165)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_31",
    "data-name": "Trazado 31",
    d: "M351.19,326.223,304.4,401.236h-6.668l46.679-75.012Z",
    transform: "translate(29.174 -315.165)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_32",
    "data-name": "Trazado 32",
    d: "M340.315,326.223l-46.784,75.012H286.86l46.681-75.012Z",
    transform: "translate(13.321 -315.165)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_33",
    "data-name": "Trazado 33",
    d: "M329.441,326.223l-46.787,75.012h-6.668l46.679-75.012Z",
    transform: "translate(-2.532 -315.165)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_34",
    "data-name": "Trazado 34",
    d: "M318.566,326.223l-46.784,75.012h-6.67l46.681-75.012Z",
    transform: "translate(-18.385 -315.165)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_35",
    "data-name": "Trazado 35",
    d: "M307.692,326.223l-46.787,75.012h-6.668l46.679-75.012Z",
    transform: "translate(-34.238 -315.165)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_36",
    "data-name": "Trazado 36",
    d: "M296.818,326.223l-46.787,75.012h-6.668l46.681-75.012Z",
    transform: "translate(-50.091 -315.165)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_37",
    "data-name": "Trazado 37",
    d: "M285.943,326.223l-46.787,75.012h-6.668l46.681-75.012Z",
    transform: "translate(-65.944 -315.165)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_38",
    "data-name": "Trazado 38",
    d: "M275.069,326.223l-46.787,75.012h-6.668l46.681-75.012Z",
    transform: "translate(-81.797 -315.165)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_39",
    "data-name": "Trazado 39",
    d: "M264.195,326.223l-46.787,75.012H210.74l46.681-75.012Z",
    transform: "translate(-97.649 -315.165)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_40",
    "data-name": "Trazado 40",
    d: "M253.32,326.223l-46.787,75.012h-6.668l46.681-75.012Z",
    transform: "translate(-113.502 -315.165)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_41",
    "data-name": "Trazado 41",
    d: "M242.446,326.223l-46.787,75.012h-6.668l46.681-75.012Z",
    transform: "translate(-129.355 -315.165)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_42",
    "data-name": "Trazado 42",
    d: "M231.571,326.223l-46.787,75.012h-6.668L224.8,326.223Z",
    transform: "translate(-145.208 -315.165)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_43",
    "data-name": "Trazado 43",
    d: "M220.7,326.223,173.91,401.236h-6.668l46.681-75.012Z",
    transform: "translate(-161.061 -315.165)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_14",
    "data-name": "Grupo 14",
    transform: "translate(-459.048 2434)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_45",
    "data-name": "Trazado 45",
    d: "M219.7,316.6l-1.376,2.787-3.075.445,2.227,2.17-.526,3.062,2.75-1.445,2.75,1.445L221.922,322l2.227-2.17-3.075-.445Z",
    transform: "translate(-125.954 -316.602)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_46",
    "data-name": "Trazado 46",
    d: "M210.615,316.6l-1.376,2.787-3.075.445L208.39,322l-.526,3.062,2.75-1.445,2.75,1.445L212.839,322l2.227-2.17-3.075-.445Z",
    transform: "translate(-139.194 -316.602)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_47",
    "data-name": "Trazado 47",
    d: "M201.532,316.6l-1.376,2.787-3.075.445,2.227,2.17-.526,3.062,2.75-1.445,2.75,1.445L203.757,322l2.227-2.17-3.075-.445Z",
    transform: "translate(-152.435 -316.602)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_48",
    "data-name": "Trazado 48",
    d: "M192.45,316.6l-1.376,2.787-3.075.445,2.227,2.17-.526,3.062,2.75-1.445,2.75,1.445L194.674,322l2.227-2.17-3.075-.445Z",
    transform: "translate(-165.675 -316.602)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_49",
    "data-name": "Trazado 49",
    d: "M183.367,316.6l-1.376,2.787-3.075.445,2.227,2.17-.526,3.062,2.75-1.445,2.75,1.445L185.592,322l2.227-2.17-3.075-.445Z",
    transform: "translate(-178.916 -316.602)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineas);
export default __webpack_public_path__ + "static/media/lineas.39f1c095fbcf879b229cead3b1bc1cc9.svg";
export { ForwardRef as ReactComponent };